import { render } from "./ViewFolder.vue?vue&type=template&id=4cd42f8a&scoped=true&lang=pug"
import script from "./ViewFolder.vue?vue&type=script&lang=js"
export * from "./ViewFolder.vue?vue&type=script&lang=js"

import "./ViewFolder.vue?vue&type=style&index=0&id=4cd42f8a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cd42f8a"]])

export default __exports__